import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Drawer, Space } from 'antd';
import {
	XButton2,
	XThemeDrawer,
	XThemeFilterButton,
	XThemeForm,
} from '../../styles/GlobalThemeStyle';
import { XForm } from './CaseSearchStyle';
import { XTheme2Button } from '../../styles/GlobalThemeStyleCQ';

const CaseSearch = (props) => {
	let { onClose, open, applyFilters, clearFilters, form } = props;
	const [displayOrganization, setDisplayOrganization] = useState(false);
	const [displayRegion, setDisplayRegion] = useState(false);
	const [displayHospital, setDisplayHospital] = useState(false);

	useEffect(() => {
		const userRole = localStorage.getItem('role');

		if (userRole === 'organization-admin') {
			setDisplayOrganization(true);
		} else if (userRole === 'region-admin') {
			setDisplayOrganization(true);
			setDisplayRegion(true);
		} else if (userRole === 'hospital-admin') {
			setDisplayOrganization(true);
			setDisplayRegion(true);
			setDisplayHospital(true);
		}
	}, []);

	return (
		<>
			<XThemeDrawer
				title={'Filter'}
				placement="right"
				onClose={onClose}
				open={open}
				extra={
					<Space>
						<XTheme2Button
							className="noBackground"
							onClick={() => {
								clearFilters();
								onClose();
							}}
						>
							Clear
						</XTheme2Button>
					</Space>
				}
				zIndex="9999"
			>
				<XThemeForm name="search" layout="vertical" form={form}>
					<Row gutter={(15, 30)}>
						{props.filters?.length > 0 &&
							props.filters.map((filter, index) => {
								const filterName = filter.props.name;
								if (
									(filterName === 'organization' &&
										displayOrganization) ||
									(filterName === 'region' &&
										displayRegion) ||
									(filterName === 'hospital' &&
										displayHospital)
								) {
									return null;
								}
								return (
									<Col xs={24} sm={24} lg={24} xl={24}>
										{filter}
									</Col>
								);
							})}
					</Row>

					<XTheme2Button
						className="w-100"
						onClick={() => {
							applyFilters();
							onClose();
						}}
					>
						Apply
					</XTheme2Button>
				</XThemeForm>
			</XThemeDrawer>
		</>
	);
};

export default CaseSearch;
